// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2FtCV","row":"Node_row__hdNZ9","label":"Node_label__3B6GX","footer":"Node_footer__10_MH"};